import { HttpParams } from '@angular/common/http';

export class MpxHttpParamsBuilder {
  private httpParams = new HttpParams();

  public append(param: string, value: string): MpxHttpParamsBuilder {
    this.httpParams = this.httpParams.append(param, value);
    return this;
  }

  public discardEmpty(): MpxHttpParamsBuilder {
    this.httpParams.keys().forEach((key) => {
      if (!this.httpParams.get(key)) {
        this.httpParams = this.httpParams.delete(key);
      }
    });
    return this;
  }

  public build(): HttpParams {
    this.append('range', '0-1000');

    let ret = new HttpParams();

    this.httpParams.keys().forEach((key) => (ret = ret.append(key, this.httpParams.get(key))));

    return ret;
  }
}
